// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// Scrolls a sidebar row into view WITHIN ITS PANE ONLY. scrollIntoView
// walks every scrollable ancestor, so on pages where the document itself
// scrolls (admin TreasureChest) it also dragged the whole page - and the
// map under the cursor - along to chase a row. Here only the nearest
// scrollable ancestor moves; everything beyond it stays put.
export const scrollRowIntoPane = (row: HTMLElement): void => {
  let pane = row.parentElement;
  while (pane) {
    const { overflowY } = window.getComputedStyle(pane);
    if ((overflowY === 'auto' || overflowY === 'scroll') && pane.scrollHeight > pane.clientHeight) break;
    pane = pane.parentElement;
  }
  if (!pane) return;
  const paneRect = pane.getBoundingClientRect();
  const rowRect = row.getBoundingClientRect();
  if (rowRect.top < paneRect.top) {
    pane.scrollTop += rowRect.top - paneRect.top;
  } else if (rowRect.bottom > paneRect.bottom) {
    pane.scrollTop += rowRect.bottom - paneRect.bottom;
  }
};

export default scrollRowIntoPane;
